<template>
  <div class="dialog">
    <div class="dialog-header">{{ ts('Payment Method')['Payment Method'] }}</div>
    <div class="dialog-content pay-method">
      <div class="">
        <template v-for="payment in paymentList">
          <el-radio v-model="platForm" label="Stripe" v-if="payment=='Stripe'">
            <img src="../assets/images/stripe.svg" />
          </el-radio>
          <el-radio v-model="platForm" label="Paypay" v-if="payment=='Paypay'">
            <img src="../assets/images/paypay.svg" />
          </el-radio>
          <el-radio v-model="platForm" label="Square" v-if="payment=='Square'">
            <img src="../assets/images/squareup.png" style="width: 90%;height: 90%"  />
          </el-radio>

        </template>
      </div>
      <div class="dialog-footer">
        <el-button type="primary" class="btn btn-theme" :loading="btnLoading" @click="confirm">{{ ts('CONFIRM')['CONFIRM'] }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { LanguagePackage } from '@/mixins/LanguagePackage'
import {getAction} from "@/api/manage";

export default {
  name: 'PayMethod',
  mixins: [LanguagePackage],
  props:['orderType','orderId'],
  data() {
    return {
      platForm: null,
      btnLoading: false,
      paymentList:[]
    }
  },
  methods: {
    confirm() {
      this.btnLoading = true
      setTimeout(() => {
        this.btnLoading = false
      }, 1500)
      this.$emit('confirm', this.platForm)
    },
    cancelLoading() {
      this.btnLoading = false
    },
    loadPayment(){
      if(this.orderId && this.orderType){
        this.paymentList = [];
        getAction("/payment/getPaymentList",
            {orderId:this.orderId,orderType:this.orderType}).then(rs=>{
          if(rs.success){
            this.paymentList = rs.result;
          }
        })
      }
    }
  },
  mounted() {
    this.loadPayment();
  },
  watch:{
    orderType(){
      this.loadPayment();
    },
    orderId(){
      this.loadPayment();
    }
  }
}
</script>

<style scoped lang="sass"></style>
